import type { CSSProperties } from 'react';

import type { DOMOutputSpec } from '@tiptap/pm/model';
import classNames from 'classnames';

import { convertToHTMLAttributes } from '@/utils/convertToHTMLAttributes';

import columnStyles from './Column.css';
import type { ColumnElementProps, TColumnElement } from './Column.type';

export function getColumnAttributes(props: ColumnElementProps) {
  const { element, className, attributes } = props;
  const { customAttributes } = element.attrs || {};

  return {
    ...customAttributes,
    className: classNames(className, columnStyles.columnItemElement, customAttributes?.className),
    style: {
      ...calculateWidthStyling(props.element.attrs?.width),
      '--gap-total-width': 'calc(var(--gap) * (var(--num-children) - 1))',
      '--gap-mobile-total-width': 'calc(var(--gap-mobile) * (var(--num-children) - 1))',
      '--border-radius': props.element.attrs?.borderRadius,
      '--border-width': props.element.attrs?.borderWidth,
      '--border-color': props.element.attrs?.borderColor,
      '--border-style': props.element.attrs?.borderStyle,
    } as CSSProperties,
    ...attributes,
  };
}

// This is used by the Tiptap Column extension
export function getColumnRenderHTML({ node, HTMLAttributes }: { node: Node; HTMLAttributes?: Record<string, any> }) {
  return [
    'div',
    {
      ...convertToHTMLAttributes(
        getColumnAttributes({ element: node as unknown as TColumnElement, children: [], attributes: HTMLAttributes }),
      ),
    },
    0,
  ] as DOMOutputSpec;
}

function calculateWidthStyling(width?: number) {
  return {
    flexGrow: 1,
    flexBasis: width || 'auto',
    minWidth: 0,
  } as CSSProperties;
}
